<div class="alerts-container">
  <ab-alerts-common></ab-alerts-common>
  <ab-undo-alert class="undo-alert-container"></ab-undo-alert>
  <ab-outdated-notifier-warning-alert
    [projectId]="project.id"
  ></ab-outdated-notifier-warning-alert>
  <ab-account-error-cap-reached [user]="user"></ab-account-error-cap-reached>
</div>
<div class="project-errors-container">
  <div
    class="col-lg-5 sidebar d-md-flex flex-md-column"
    [ngClass]="{ 'sidebar--group-is-active': $state.includes('groups-show') }"
  >
    <div ui-view="filters"></div>
    <div class="groups-wrapper" ui-view="groups"></div>
  </div>
  <div
    class="main d-md-flex flex-md-column flex-md-grow-1"
    ui-view="notice"
  ></div>
</div>
